/**
 * De lessen (sessies) van deze leerkracht, met de klassen en stellingen
 * erbij om ze een naam te geven: een les heeft er zelf geen, en wordt
 * herkend aan de stelling, de klas en de datum. Gebruikt door de
 * tabbladen Sessies en Resultaten.
 */
import { useEffect, useState } from 'react';

export function useLessen(api) {
  const [sessies, setSessies] = useState([]);
  const [klassen, setKlassen] = useState([]);
  const [stellingen, setStellingen] = useState([]);
  const [laden, setLaden] = useState(false);

  const haalSessies = async () => {
    setLaden(true);
    try {
      const data = await api.haalSessies();
      if (data.success) setSessies(data.data);
    } catch (err) { console.error('Fout:', err); }
    finally { setLaden(false); }
  };

  useEffect(() => {
    haalSessies();
    const haal = async (vraag, zet) => {
      try {
        const data = await vraag();
        if (data.success) zet(data.data);
      } catch (err) { console.error('Fout:', err); }
    };
    haal(api.haalKlassen, setKlassen);
    haal(api.haalStellingen, setStellingen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    sessies, klassen, stellingen, laden, haalSessies,
    stellingVan: (sessie) => stellingen.find(s => s.id === sessie.statement_id),
    klasVan: (sessie) => klassen.find(k => k.id === sessie.class_id),
  };
}
